const config = {
    id: 28,
    name: "轮播导航",
    type: 1,
    module_code: "swiper_nav",
    icon: "icon-tms-swiper_nav",
    font_icon: "&#xe60e;",
    style_type: 1,
    link_type: 5,
    link_data: [{
            main_title: "主标题",
            sub_title: "副标题",
            background_color: "#ff6600",
            sub_title_background: "#F19CD9",
            sub_title_color: "",
            imgUrl: "",
            main_title_color: ""
        },
        {
            main_title: "主标题",
            sub_title: "副标题",
            background_color: "#ff6600",
            sub_title_background: "#F19CD9",
            imgUrl: "",
            sub_title_color: "",
            main_title_color: ""
        },
        {
            main_title: "主标题",
            sub_title: "副标题",
            background_color: "#ff6600",
            sub_title_background: "#F19CD9",
            imgUrl: "",
            sub_title_color: "",
            main_title_color: ""
        },
        {
            main_title: "主标题",
            sub_title: "副标题",
            background_color: "#ff6600",
            sub_title_background: "#F19CD9",
            imgUrl: "",
            sub_title_color: "",
            main_title_color: ""
        }
    ]
};

export default config;